const BASE_URL = '/v1/advertisement-displays'

import fetch from '@/api/fetch-types/fetch'

interface ICreateResponse {
  id: string
}

export interface IDisplaysListResponse {
  items: {
    id: string
    name: string
    advertisementId: string
    resolution: string
    createdAt: string
    createdById: string
  }[]
  page: number
  offset: number
  total: number
  pageSize: number
}

export const createDisplayService = async (body: {
  name: string
  resolution: string
  advertisementId?: string
}) => await fetch<ICreateResponse>(BASE_URL, { ...body }, true, 'POST')

export const editDisplayService = async (
  id: string,
  body: {
    name: string
    advertisementId?: string
  }
) => await fetch<ICreateResponse>(`${BASE_URL}/${id}`, { ...body }, true, 'PUT')

export const deleteDisplayService = async (id: string) =>
  await fetch<ICreateResponse>(`${BASE_URL}/${id}`, {}, true, 'DELETE')

export const savedDisplaysService = async (page: number, pageSize = 12) =>
  await fetch<IDisplaysListResponse>(
    BASE_URL,
    {
      page: page,
      pageSize: pageSize
    },
    true,
    'GET'
  )
